'use client';

import styles from '@styles/Footer/copyright.module.scss';
import { getAppConfiguration } from '@utils/browserEnv';
import React from 'react';

/**
 * Rendered from the root layout, which sits in the static shell, so the year cannot be read at
 * render time — Cache Components rejects `new Date()` there, and a prerendered "now" would be
 * frozen at build time anyway. `useEffect` fills it in on the client after mount; until then the
 * range end is omitted rather than guessed.
 */
const Copyright: React.FC = () => {
  const { mdcLandingUrl } = getAppConfiguration();
  const [currentYear, setCurrentYear] = React.useState<number | null>(null);

  React.useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <div className={styles.container}>
      <p className={styles.container__text}>
        All Rights Reserved © 2019{currentYear ? `-${currentYear}` : ''}{' '}
        <a href={mdcLandingUrl} target="_blank" rel="noreferrer">
          Marine Data Cloud™
        </a>{' '}
        · v{process.env.NEXT_PUBLIC_APP_VERSION}
      </p>
    </div>
  );
};

export default Copyright;
